import React from "react";
import { motion } from "framer-motion";
import Hero from "../components/Hero";
import Problem from "../components/Problem";
import PlatformSection from "../components/PlatformSection";
import Features from "../components/Features";
import PreCheckIn from "../components/PreCheckIn";
import CustomerSuccess from "../components/CustomerSuccess";
import WhyInplass from "../components/WhyInplass";
import FutureVision from "../components/FutureVision";
import Testimonials from "../components/Testimonials";
import CTA from "../components/CTA";

export default function Home() {
  return (
    <motion.main
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.4 }}
      data-testid="page-home"
    >
      <Hero />
      <Problem />
      <PlatformSection />
      <Features />
      <PreCheckIn />
      <WhyInplass />
      <CustomerSuccess />
      <FutureVision />
      <Testimonials />
      <CTA />
    </motion.main>
  );
}
